import i18n from '~/locales/i18n';

i18n.addResourceBundle('ar', 'app', {
  savedPropertiesTitle: 'عقارات محفوظة',
  savedProperties: 'العقارات المحفوظة',
  savedPropertiesShareAll: 'شارك العقارات',
  savedPropertiesDeleteAll: 'حذف المفضلة',
  savedPropertiesFavoritesTab: 'المفضلة',
  savedPropertiesNotesTab: 'بها ملاحظات',
  savedPropertiesContactedTab: 'تم التواصل',
  savedPropertiesAddNote: 'أضف ملاحظاتك هنا',
  savedPropertiesShareProperty: 'مشاركة العقار',
  savedPropertiesDeleteNote: 'حذف الملاحظة',
  savedPropertiesReport: 'إبلاغ',
  savedPropertiesEmptyTitle: 'لا توجد عقارات محفوظة',
  savedPropertiesEmptyDescription:
    'ابدأ بحفظ العقارات التي تهمك لتظهر هنا لاحقًا.',
  savedPropertiesLatest: 'الأحدث',
  savedPropertiesHighestPrice: 'الأعلى سعرًا',
  savedPropertiesLowestPrice: 'الأقل سعرًا',
  savedPropertiesLargestArea: 'الأكبر مساحة',
  savedPropertiesSmallestArea: 'الأقل مساحة',
  savedPropertiesCall: 'اتصال',
  savedPropertiesWhatsapp: 'واتساب',
  savedPropertiesEditNotePrompt: 'اكتب ملاحظتك',
  savedPropertiesDeleteSingle: 'حذف من المفضلة',
  savedPropertiesOpenMenu: 'فتح قائمة العقار',
  pricePerMeterAbbreviation: 'ج/ م²',
  downPayment: 'مقدم',
  upTo: ' قسط على',
  years: 'سنوات',
  currencyEg: 'جنيه',
  millions: ' مليون',
  thousands: ' ألف',
  billions: ' مليار',
  trillion: ' تريليون',
  and: 'و',
  perMonth: 'شهر',
  pound: 'ج.م',
  daily: 'اليومي',
  monthly: 'الشهري',
  yearly: 'السنوي',
  weekly: 'الأسبوعي',
  day: 'يوم',
  days: 'أيام',
  week: 'أسبوع',
  weeks: 'أسابيع',
  mo: 'شهر',
  mos: 'شهور',
  year: 'سنة',
  noteModalTitle: 'اضف ملاحظة',
  noteModalPlaceholder: 'اضف ملاحظة هنا ..',
  character: 'حرف',
  update: 'حفظ',
  sortBy: 'ترتيب حسب',
  deleteFavoriteConfirm: 'هل انت متأكد من حذف جميع العقارات المحفوظة ؟',
  deleteFavoriteTitle: 'حذف العقارات المحفوظة',
  shareTitle: 'مشاركة العقار',
  emptySavedPropertiesTitle: 'ليس لديك أي عقارات محفوظة',
  emptySavedNotesTitle: 'ليس لديك أي عقارات بها ملاحظات',
  emptySavedPropertiesButton: 'ابدء بالإضافة الآن',
  sharePropertiesTitle: 'مشاركة العقارات',
  sharePropertiesInfo: 'ينتهي صلاحية هذا الرابط خلال 7 ايام',
  shareNotes: 'مشاركة الملاحظات',
  addToFavorites: 'إضافة للمُفضلة',
  ads: 'اعلانات',
  favorite: 'مُفضلة',
  reportModalTitle: 'إبلاغ',
  listingRateFormTitle: 'شاركنا تجربتك مع هذا العقار ؟',
  listingRateFormIssueTitle: 'ماهى المشكلة؟',
  listingRateFormExplainIssue: 'اشرح المشكلة',
  requiredComment: 'يجب شرح سبب المشكلة',
  requiredSatisfactionType: 'برجاء اختر قيمة',
  requiredReason: 'برجاء اختيار سبب',
});
